import React from "react";
import { COUNTER_TABLE, STANDARD_TABLE } from "../../../../constants/app";

const SelectBookingType = (props) => {
  const { pageColor, handleSetBookingType, bookingType } = props;
  const isStandard = React.useMemo(
    () => bookingType === STANDARD_TABLE,
    [bookingType]
  );
  const isCounted = React.useMemo(
    () => bookingType === COUNTER_TABLE,
    [bookingType]
  );
  return (
    <div className="row p-4">
      <div className="col-6">
        <button
          className={`btn w-100 py-2 fw-bold border-0 ${
            isStandard ? "text-dark" : "text-muted"
          }`}
          onClick={() => handleSetBookingType(STANDARD_TABLE)}
          style={{
            backgroundColor: isStandard ? pageColor : "#f8f9fa",
            fontSize: "1.1rem",
          }}
        >
          {isStandard && <span className="me-2">✓</span>}
          テーブル席
        </button>
      </div>
      <div className="col-6">
        <button
          className={`btn w-100 py-2 fw-bold border-0 ${
            isCounted ? "text-dark" : "text-muted"
          }`}
          onClick={() => handleSetBookingType(COUNTER_TABLE)}
          style={{
            backgroundColor: isCounted ? pageColor : "#f8f9fa",
            fontSize: "1.1rem",
          }}
        >
          {isCounted && <span className="me-2">✓</span>}
          カウンター席
        </button>
      </div>
    </div>
  );
};

export default React.memo(SelectBookingType);
